import React, { useEffect, useState } from 'react';
import Content from "../../../components/layout/Content";
import { useDispatch, useSelector } from "react-redux";
import { ReasonModal } from "./Reason";
import { fetchWriteOffFormReasons, deleteWriteOffReason } from "../../../action/reasons";
import swal from 'sweetalert';
import WriteOffReasonList from "./writeOffReasonList";

const WriteOffReason = () => {
    const dispatch = useDispatch();
    const reasons = useSelector(state => state.reasons.items);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);

    useEffect(() => {
        dispatch(fetchWriteOffFormReasons());
    }, [dispatch]);

    const onRefresh = () => {
        dispatch(fetchWriteOffFormReasons());
    };

    const openModalForAdd = () => {
        setIsModalOpen(true);
        setIsEditMode(false);
        setCurrentItem(null);
    };

    const openModalForEdit = (reason) => {
        setIsModalOpen(true);
        setIsEditMode(true);
        setCurrentItem(reason);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsEditMode(false);
        setCurrentItem(null);
    };

    const handleDelete = (item) => {
        swal({
            title: "Вы уверены?",
            text: `Вы хотите удалить причину "${item.name}"?`,
            icon: "warning",
            buttons: ["Отмена", "Удалить"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteWriteOffReason(item.id)).then(() => {
                    dispatch(fetchWriteOffFormReasons());
                    swal("Причина успешно удалена!", { icon: "success" });
                });
            }
        });
    };

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Причины списаний</h3>
                    </div>
                    <div className="kt-subheader__toolbar">
                        <button onClick={openModalForAdd} className="btn btn-success btn-icon-sm">
                            Добавить причину
                        </button>
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Content>
            {renderSubHeader()}
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <WriteOffReasonList
                            reasons={reasons}
                            onEdit={openModalForEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <ReasonModal
                    onClose={closeModal}
                    isEditMode={isEditMode}
                    reason={currentItem}
                />
            )}
        </Content>
    );
};

export default WriteOffReason;